import React, { Component } from 'react';
import { Icon } from 'antd';

class ContentList extends Component {
    render() {
        const { data, render, onRemove, className = '', deteable = true, circle = false } = this.props;
        return (
            <div className={`content-list ${className}`}>
                {
                    (data || []).map((item, index) => {
                        const text = render(item);
                        return (
                            <div className="content-item" key={index}>
                                <div className="item-text" title={text}>
                                    {text}
                                </div>
                                <div className="item-icon">
                                    { deteable && <Icon type={!circle ? "close-circle" : "close-circle-o" } onClick={() => onRemove(index)}/> }
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}

export default ContentList;


// WEBPACK FOOTER //
// ./src/components/basicElement/ContentList.js